import {
    CREATE_CALENDAR,
    CREATE_CALENDAR_SUCCESS,
    CLEAR_CREATED_CALENDAR,

    GET_ALL_CALENDARS,
    GET_ALL_CALENDARS_SUCCESS,

    GET_CALENDAR,
    GET_CALENDAR_SUCCESS,

    GET_PLAYER_CALENDAR,
    GET_PLAYER_CALENDAR_SUCCESS,

    UPDATE_CALENDAR,
    UPDATE_CALENDAR_SUCCESS,

    DELETE_CALENDAR,
    DELETE_CALENDAR_SUCCESS,

    DUPLICATE_CALENDAR,
    DUPLICATE_CALENDAR_SUCCESS,

    FILTER_CALENDAR,
    FILTER_CALENDAR_SUCCESS,
    UPDATE_DOOR_DRAG_DROP,
    UPDATE_DOOR_DRAG_DROP_SUCCESS,

} from './constants';

/**
 *
 * @param title
 * @param lang
 * @returns {{type: string, title: *, lang: *}}
 */
const createCalendar = ( title, lang ) => ( {
    type: CREATE_CALENDAR,
    title,
    lang
} );
/**
 *
 * @param calendar
 * @returns {{calendar: *, type: string}}
 */
const createCalendarSuccess = calendar => ( {
    type: CREATE_CALENDAR_SUCCESS,
    calendar
} );
/**
 *
 * @param title
 * @param lang
 * @param calendarID
 * @returns {{calendarID: *, type: string, title: *, lang: *}}
 */
const duplicateCalendar = ( title, lang, calendarID ) => ( {
    type: DUPLICATE_CALENDAR,
    title,
    lang,
    calendarID
} );
/**
 *
 * @param calendars
 * @returns {{calendars: *, type: string}}
 */
const duplicateCalendarSuccess = calendars => ( {
    type: DUPLICATE_CALENDAR_SUCCESS,
    calendars
} );
/**
 *
 * @returns {{type: string}}
 */
const clearCreatedCalendar = () => ( {
    type: CLEAR_CREATED_CALENDAR
} );
/**
 *
 * @param page
 * @param tenant
 * @returns {{page: *, type: string, tenant: *}}
 */
const getAllCalendars = ( page, tenant ) => ( {
    type: GET_ALL_CALENDARS,
    page,
    tenant
} );
/**
 *
 * @param calendars
 * @returns {{calendars: *, type: string}}
 */
const getAllCalendarsSuccess = calendars => ( {
    type: GET_ALL_CALENDARS_SUCCESS,
    calendars
} );
/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const getCalendar = id => ( {
    type: GET_CALENDAR,
    id
} );
/**
 *
 * @param calendar
 * @returns {{calendar: *, type: string}}
 */
const getCalendarSuccess = calendar => ( {
    type: GET_CALENDAR_SUCCESS,
    calendar
} );
/**
 *
 * @param id
 * @param key
 * @returns {{id: *, type: string, key: *}}
 */
const getPlayerCalendar = ( id, key ) => ( {
    type: GET_PLAYER_CALENDAR,
    id,
    key
} );
/**
 *
 * @param playerCalendar
 * @returns {{type: string, playerCalendar: *}}
 */
const getPlayerCalendarSuccess = playerCalendar => ( {
    type: GET_PLAYER_CALENDAR_SUCCESS,
    playerCalendar
} );
/**
 *
 * @param id
 * @param value
 * @returns {{id: *, type: string, value: *}}
 */
const updateCalendar = ( id, value ) => ( {
    type: UPDATE_CALENDAR,
    id,
    value
} );
/**
 *
 * @param calendar
 * @returns {{calendar: *, type: string}}
 */
const updateCalendarSuccess = calendar => ( {
    type: UPDATE_CALENDAR_SUCCESS,
    calendar
} );
/**
 *
 * @param id
 * @returns {{id: *, type: string}}
 */
const deleteCalendar = id => ( {
    type: DELETE_CALENDAR,
    id
} );
/**
 *
 * @param data
 * @param id
 * @returns {{data: *, id: *, type: string}}
 */
const deleteCalendarSuccess = ( data, id ) => ( {
    type: DELETE_CALENDAR_SUCCESS,
    data,
    id
} );
/**
 *
 * @param typeQuiz
 * @param page
 * @param tenant
 * @param search
 * @param filter
 * @returns {{filter: *, typeQuiz: *, search: *, page: *, type: string, tenant: *}}
 */
const updateCalendarFilter = ( typeQuiz, page, tenant, search, filter ) => ( {
    type: FILTER_CALENDAR,
    typeQuiz,
    page,
    tenant,
    search,
    filter
} );
/**
 *
 * @param calendars
 * @returns {{calendars: *, type: string}}
 */
const updateCalendarFilterSuccess = calendars => ( {
    type: FILTER_CALENDAR_SUCCESS,
    calendars
} );

const updateDoorDragDrop = (calendarID, result) => ({
    type: UPDATE_DOOR_DRAG_DROP,
    calendarID,
    result
});

const updateDoorDragDropSuccess = ( calendar ) => ({
    type: UPDATE_DOOR_DRAG_DROP_SUCCESS,
    calendar
});

export {
    updateDoorDragDrop,
    updateDoorDragDropSuccess,
    updateCalendarFilter,
    updateCalendarFilterSuccess,
    createCalendar,
    createCalendarSuccess,
    clearCreatedCalendar,
    getAllCalendars,
    getAllCalendarsSuccess,
    getCalendar,
    getCalendarSuccess,
    updateCalendar,
    updateCalendarSuccess,
    getPlayerCalendar,
    getPlayerCalendarSuccess,
    deleteCalendar,
    deleteCalendarSuccess,
    duplicateCalendar,
    duplicateCalendarSuccess
};